import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import {
  FormArray,
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
} from "@angular/forms";
import { ToastService } from "ng-uikit-pro-standard";
import { DataService } from "src/app/data.service";
@Component({
  selector: "app-duplicaterulelist",
  templateUrl: "./duplicaterulelist.component.html",
  styleUrls: ["./duplicaterulelist.component.scss"],
})
export class DuplicaterulelistComponent implements OnInit {
  isLoading = false;
  isError = false;
  errorMessage = "";
  tabs = [];
  mode = "";
  id = "";
  name = "";
  objectId = "";
  objectName = "";
  // displayedColumns: string[] = ["label", "name"];

  // dataSource: any[] = [];

  displayedColumns: string[] = [
    "action",
    "name",
    "object",
    "description",
    "modifiedby",
    "modifieddate",
  ];
  dataSource = "";
  matchingrule: any;
  duplicaterule: any;

  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000,
    };
    this.toastrService.success(data, "", options);
  }
  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Application Error!", options);
  }

  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark",
    };
    this.toastrService.warning(data, "", options);
  }
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private toastrService: ToastService,
    private dataService: DataService
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      // this.mode = this.route.snapshot.params.mode;
      // this.objectName = this.route.snapshot.params.objectname;
    });

    this.getDuplicateRule();
  }

  cancel() {
    this.router.navigateByUrl("/home");
  }
  new() {
    this.router.navigateByUrl("/home/duplicaterule/objectSelect/new");
  }

  // edit(id: any, name: any, objectname: any, objectid: any) {
  //   this.router.navigateByUrl(
  //     "/home/convertsetting/edit/" +
  //       id +
  //       "/" +
  //       name +
  //       "/" +
  //       objectname +
  //       "/" +
  //       objectid
  //   );
  // }

  getDuplicateRule() {
    return new Promise((resolve, reject) => {
      console.log("getDuplicateRule");

      // alert(id)
      const organizationid = localStorage.getItem("crm_orgid");
      // const domain = localStorage.getItem("domain");
      // const subdomain = localStorage.getItem("subdomain");
      const domain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      );
      const subdomain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      );
      this.isLoading = true;
      this.dataService
        .getDuplicateRule(organizationid, domain, subdomain)
        .subscribe(
          (res) => {
            console.log("res", res);

            if (res.success == 1) {
              this.duplicaterule = res.data.duplicaterule;
              console.log("Doneeee****", this.duplicaterule);

              if (this.duplicaterule != null) {
                this.dataSource = this.duplicaterule.map((item) => ({
                  id: item.id,
                  label: item.labelname,
                  name: item.name,
                  object: item.metaobjectname,
                  description: item.description,
                  modifiedby: item.modifiedby,
                  modifieddate: item.modifieddate,
                  objectname: item.metaobjectname,
                  objectid: item.metaobjectid,
                  // type: item.actiontype,
                  // content: item.content,
                  // metalayoutid: item.metalayoutid,
                }));
              }

              this.isLoading = false;
            } else {
              console.log("Error while saving");
              this.isLoading = false;
            }
          },
          (err) => {
            console.log("Error***:", err);
            this.errorMessage = err.message;
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        );
    });
  }

  editApp(element: any) {
    this.router.navigateByUrl(
      "/home/duplicaterule/create/edit/" +
        element.name +
        "/" +
        element.id +
        "/" +
        element.objectname +
        "/" +
        element.objectid
    );
  }

  delete(id: number) {
    // alert(id)
    const organizationid = localStorage.getItem("crm_orgid");
    const domain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.domain`
    );
    const subdomain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.subdomain`
    );
    const confirmDelete = window.confirm("Are you sure you want to delete?");

    if (!confirmDelete) {
      return;
    }
    this.isLoading = true;
    this.dataService
      .deleteDuplicateRule(organizationid, id, domain, subdomain)
      .subscribe(
        (res) => {
          // alert('****res****' + JSON.stringify(res));
          console.log(res);
          if (res.success == 1) {
            // alert("Are you sure?")

            this.showSuccess(res.message);
            this.isLoading = false;

            window.location.reload();
          } else {
            console.log("Failed to delete!");
            this.isLoading = false;
            this.showError(res.message);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          this.showError(err.message);
        }
      );
  }
}
